import { useState } from "react";
import { Link } from "react-router-dom";
import JsonLd from "@/components/base/JsonLd";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackTop from "@/components/feature/BackTop";
import { usePageMeta } from "@/hooks/usePageMeta";
import { faqs, site } from "@/mocks/content";

export default function FaqPage() {
  usePageMeta(
    "常见问题 FAQ - 今日新瓜订阅、投稿与转载说明",
    "今日新瓜常见问题汇总：什么是独家内幕栏目、如何保证爆料可信、怎样投稿与纠错、内容定位与转载规范等高频疑问，一次讲清楚。",
  );
  const [query, setQuery] = useState("");
  const list = faqs.filter((f) => f.q.includes(query.trim()) || f.a.includes(query.trim()));

  const schemaFaq = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <>
      <JsonLd data={schemaFaq} />
      <Navbar />
      <main>
        <section className="border-b border-background-200 bg-background-50">
          <div className="mx-auto max-w-3xl px-4 py-12 text-center md:px-6 md:py-16">
            <p className="mb-2 flex items-center justify-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-600">
              <i className="ri-question-answer-line" /> Help Center
            </p>
            <h1 className="font-heading text-3xl font-black text-foreground-900 md:text-4xl">
              常见问题
            </h1>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              关于订阅、投稿、纠错、内容定位与转载，这里都有答案。
            </p>
            <div className="mx-auto mt-6 flex max-w-xl items-center gap-2 rounded-full border border-background-200 bg-background-100 px-4 py-2.5 focus-within:border-primary-400">
              <i className="ri-search-line text-foreground-500" />
              <input
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="搜索你想了解的问题……"
                className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              />
            </div>
          </div>
        </section>

        <section className="mx-auto max-w-3xl px-4 py-10 md:px-6">
          {list.length === 0 ? (
            <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-background-300 bg-background-50 py-16 text-center">
              <i className="ri-inbox-2-line text-4xl text-foreground-300" />
              <p className="mt-3 text-sm text-foreground-600">
                没有找到与“{query}”相关的问题
              </p>
            </div>
          ) : (
            <div className="space-y-3">
              {list.map((f) => (
                <details
                  key={f.q}
                  className="group rounded-2xl border border-background-200 bg-background-50 p-5 transition-colors open:border-primary-200"
                >
                  <summary className="flex cursor-pointer list-none items-center justify-between gap-4 font-heading text-base font-bold text-foreground-900">
                    <span className="flex items-start gap-3">
                      <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                        <i className="ri-question-line text-[13px]" />
                      </span>
                      {f.q}
                    </span>
                    <i className="ri-add-line shrink-0 text-xl text-foreground-400 transition-transform group-open:rotate-45" />
                  </summary>
                  <p className="mt-3 border-l-2 border-primary-200 pl-4 text-sm leading-relaxed text-foreground-700">
                    {f.a}
                  </p>
                </details>
              ))}
            </div>
          )}

          <div className="mt-10 flex flex-col items-center rounded-2xl bg-primary-50/60 p-8 text-center">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-600 text-background-50">
              <i className="ri-customer-service-2-fill text-xl" />
            </span>
            <h2 className="mt-3 font-heading text-lg font-bold text-foreground-900">
              还没找到答案？
            </h2>
            <p className="mt-1 text-sm text-foreground-600">
              直接联系我们，编辑部会在工作日尽快处理你的问题或线索。
            </p>
            <div className="mt-4 flex flex-wrap justify-center gap-3">
              <a
                href={`mailto:${site.email}`}
                className="inline-flex items-center gap-2 rounded-full bg-primary-600 px-6 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700"
              >
                <i className="ri-mail-fill" /> 发信咨询
              </a>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 px-6 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                <i className="ri-information-line" /> 了解今日新瓜
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <BackTop />
    </>
  );
}